<template>
  <div class="map-year-nav-set-wrapper">
    <year-nav-button v-for="increment in sortedIncrements"
      :key="increment"
      :state="state" 
      :direction="direction"
      :increment="increment">
    </year-nav-button>
  </div>
</template>

<script>
import MapControlsYearNavigationButton from './MapControlsYearNavigationButton';

export default {
  name: 'year-nav-set',
  // direction is either 1 or -1
  props: ['state', 'direction'],
  components: {
    'year-nav-button': MapControlsYearNavigationButton,
  },
  data() {
    return {
      increments: [1, 5],
    };
  },
  computed: {
    sortedIncrements() {
      const isDescending = this.direction < 0;
      const increments = [...this.increments];
      const lastIncrement = isDescending ? 'begining' : 'end';
      increments.push(lastIncrement);
      return isDescending ? increments.reverse() : increments;
    },
  },
};
</script>

<style>
  .map-year-nav-set-wrapper {
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// MapControlsYearNavigationSet.vue?3098bae4